import React from 'react'
import { CssBaseline } from 'fronton-react'
import ReactDOM from 'react-dom'
import App from './App'
import { Provider } from 'react-redux'
import { store } from 'redux/configureStore'
import './static/fonts/Montserrat-ExtraLight.ttf'
import './static/fonts/Montserrat-Light.ttf'
import './static/fonts/Montserrat-Regular.ttf'
import './static/fonts/Montserrat-Medium.ttf'
import './static/fonts/Montserrat-SemiBold.ttf'
import './index.css'

ReactDOM.render(
    <React.StrictMode>
        <CssBaseline>
            <Provider store={store}>
                <App />
            </Provider>
        </CssBaseline>
    </React.StrictMode>,
    document.getElementById('root')
)
